import { listenDialogsControls } from '@frontend/shared/src/utils/dialog';

export class SPADialogGentlemens extends HTMLDialogElement {
  constructor() {
    super();
  }

  connectedCallback() {
    listenDialogsControls('gentlemens');
  }
}

customElements.define('spa-dialog-gentlemens', SPADialogGentlemens, { extends: 'dialog' });
